








































import EmptyCell from "@/components/EmptyCell.vue";
import { EventBus } from "@/eventbus";
import Vue from "vue";
export default Vue.extend({
  components: { EmptyCell },
  props: ["source"],
  setup(props) {
    const investigate = () => {
      EventBus.emit("investigate", props.source);
    };

    const show_events = () => {
      EventBus.emit("show_events", props.source);
    };

    const trust_management = () => {
      console.log("props.source:", props.source);
      EventBus.emit("manage_trust", props.source);
    };

    return { investigate, show_events, trust_management };
  },
});
